type Props = { className?: string };

export default function Logo({ className }: Props) {
  return (
    <span
      className={
        'inline-flex items-center gap-2 font-display text-lg leading-none tracking-tight ' +
        (className ?? '')
      }
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        aria-hidden="true"
        className="shrink-0"
      >
        <path
          d="M2 3l5.6 8.4v7.6h2.8v-7.6L16 3"
          stroke="rgb(var(--accent))"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="17.5" cy="4.5" r="2" fill="rgb(var(--accent))" />
      </svg>
      <span>
        Yorkshire <span className="text-accent">Development</span>
      </span>
    </span>
  );
}
